<template>
  <CustomerForm :customer="resource"
                @formSubmit="createFormSubmitted($event)" />
</template>

<script>
import store from "./CustomerStore";
import CustomerForm from "./CustomerForm.vue";
import CustomerMixin from "./CustomerMixin";
import scrollTop from "@shared/services/scroll_top";

const responseStore = {
  response: {
    resource: {
      shipping_address: {},
      billing_address: {}
    }
  }
};

export default {
  name: "CustomerNew",

  title () {
    return `New Customer - ${Dashboard.currentTenant.name}`;
  },

  components: {
    CustomerForm
  },

  mixins: [CustomerMixin],

  data: function () {
    return {
      store: store,
      responseStore: this.$_.cloneDeep(responseStore)
    };
  },

  mounted () {
    this.addBreadcrumb("New Customer");
  },

  methods: {
    async createFormSubmitted (e) {
      this.handleResponseToShow(await store.create());
    },

    handleResponseToShow (response) {
      this.formChanged = false;

      if (response.success) {
        this.navigateToShowRoute(response);
        this.notifySuccess(response.successMessage);
      } else {
        this.notifyErrors(response.errorMessages);
      }

      // eslint-disable-next-line no-undef
      scrollTop();
    },

    navigateToShowRoute (response) {
      this.$router.push({
        name: "Show Customer",
        params: {
          id: response.resource.id
        }
      });
    }
  }
};
</script>
